var buttonSlot = 'slot_buttonSlot__13qi7iy0';

export { buttonSlot };
//# sourceMappingURL=slot.vanilla.mjs.map
